import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import BespokeHeaderNav, { startDiscussion } from '../components/BespokeHeaderNav';

/**
 * Layout pieces as widgets: the nav and the New Discussion button, which the
 * index otherwise renders as one fixed bar at the top of the content. Placing
 * either widget takes it out of that bar (see contentItems in forum/index.ts),
 * so it shows once, wherever the layout puts it.
 *
 * Both render only vnodes (no request), so the zone rebuilding them on every
 * redraw costs nothing.
 */

/** The nav pills / tiles, minus the button, under an optional heading. */
export const NavWidget = {
  view(vnode) {
    const title = vnode.attrs.settings.title;
    return m("div", {
      className: "Bespoke-w Bespoke-w-nav"
    }, title ? m("h4", null, title) : null, m(BespokeHeaderNav, {
      button: false,
      markRead: false
    }));
  }
};

/**
 * New Discussion: the plain button, or a prompt bar (avatar, "what are you
 * working on…", and the button) that opens the composer however it's clicked.
 */
export const ComposeWidget = {
  view(vnode) {
    const s = vnode.attrs.settings;
    const label = app.translator.trans('core.forum.index.start_discussion_button');
    const canStart = app.forum.attribute('canStartDiscussion') || !app.session.user;
    const button = m(Button, {
      icon: "fas fa-edit",
      className: "Button Button--primary IndexPage-newDiscussion",
      disabled: !canStart,
      onclick: startDiscussion
    }, label);
    if (s.style !== 'prompt') {
      return m("div", {
        className: "Bespoke-w Bespoke-w-compose"
      }, button);
    }
    return m("div", {
      className: "Bespoke-w Bespoke-w-compose Bespoke-w-compose--prompt"
    }, app.session.user ? m(Avatar, {
      user: app.session.user
    }) : null, m("button", {
      type: "button",
      className: "Bespoke-composePrompt",
      disabled: !canStart,
      onclick: startDiscussion
    }, s.prompt), button);
  }
};
flarum.reg.add('ernestdefoe-bespoke', 'forum/widgets/layoutWidgets', { NavWidget: NavWidget,ComposeWidget: ComposeWidget, });